import { useState } from "react";

// Top 6 Featured Blogs
const topBlogs = [
  {
    id: 1,
    title:
      "Why Pin Code Partners and Retailers Should Join LifeOnPlus – The Future of Digital Health",
    date: "",
    excerpt:
      "Healthcare is no longer just about hospitals and clinics. It’s about access, affordability, and preventive care delivered through digital technology.",
    image: "/blogs/1.jpeg",
    link: "/blog/1",
  },
  {
    id: 2,
    title:
      "National Nutrition Week (September 1–7): Nourishing India, One Plate at a Time",
    date: "",
    excerpt:
      "At LifeOnPlus, we believe that good nutrition is the foundation of good health. Whether it’s preventing lifestyle diseases, boosting immunity, or improving energy levels, nutrition plays a vital role in every stage of life.",
    image: "/blogs/2.jpg",
    link: "/blog/2",
  },
  {
    id: 3,
    title:
      "Your Health, Your Right: Unlocking Government Benefits Every Indian Should Know",
    date: "",
    excerpt:
      "Good health is the foundation of a strong nation. The Government of India has rolled out several initiatives to safeguard the health of its citizens— from free medical care to nutritional support, disease prevention, and digital healthcare access. Unfortunately, many people don’t know what is already available to them. Here’s a clear guide to the most important schemes and how you can access them.",
    image: "/blogs/3.jpg",
    link: "/blog/3",
  },
  {
    id: 4,
    title: "August 13: International Left-Handers Day",
    date: "",
    excerpt:
      "Celebrating the Unique 10% – The Left-Handed Community Published by LifeOnPlus | Awareness & Inclusivity Series",
    image: "/blogs/4.jpg",
    link: "/blog/4",
  },
  {
    id: 5,
    title: "World Lung Cancer Day – Let’s Breathe Better, Together",
    date: "April 7, 2025",
    excerpt:
      "Every year on August 1st, the world comes together to recognize World Lung Cancer Day — a vital reminder of the need for awareness, early detection, and lifestyle changes that can save lives.",
    image: "/blogs/5.jpg",
    link: "/blog/5",
  },
  {
    id: 6,
    title: "World Humanitarian Day – August 19th",
    date: "June 5, 2025",
    excerpt:
      "Move More. Live Stronger. Stay Healthier.Published by LifeOnPlus | Fitness & Preventive Wellness Series.",
    image: "/blogs/6.jpg",
    link: "/blog/6",
  },
];

export default function BlogsPage() {
  const [searchTerm, setSearchTerm] = useState("");

  const filteredBlogs = topBlogs.filter(
    (post) =>
      post.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      post.excerpt.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  return (
    <div className="min-h-screen bg-[#f7faf8] overflow-hidden">

      {/* =========================
          HERO / HEADER
      ========================== */}
      <section className="relative pt-10 pb-8 px-4">

        {/* Soft background glow */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[420px] h-[220px] bg-green-100/50 blur-3xl rounded-full pointer-events-none" />

        <div className="relative max-w-7xl mx-auto text-center">

          <p className="text-[11px] sm:text-xs font-semibold tracking-[3px] uppercase text-green-600 mb-2">
            LifeOnPlus
          </p>

          <h2 className="text-2xl md:text-3xl font-bold text-[#183b20] mb-2 tracking-tight">
            Featured Blogs
          </h2>

          <div className="mx-auto mt-3 w-12 h-[3px] rounded-full bg-green-600" />

        </div>
      </section>

      {/* =========================
          BLOG GRID
      ========================== */}
      <div className="max-w-7xl mx-auto px-4 pb-14">

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-7">

          {filteredBlogs.length > 0 ? (
            filteredBlogs.map((post, index) => (

              <article
                key={post.id}
                className="blog-card group relative bg-white rounded-[20px] overflow-hidden flex flex-col h-full"
                style={{
                  animationDelay: `${index * 100}ms`,
                }}
              >

                {/* =========================
                    IMAGE AREA
                ========================== */}
                <div className="relative h-56 overflow-hidden bg-[#f3f8f4]">

                  {/* Image */}
                  <img
                    src={post.image}
                    alt={post.title}
                    className="blog-image w-full h-full object-contain transition-all duration-700 ease-out"
                  />

                  {/* Subtle image overlay */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/10 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

                  {/* Floating number */}
                  <div className="absolute top-4 left-4 w-8 h-8 rounded-full bg-white/90 backdrop-blur-sm shadow-md flex items-center justify-center text-xs font-bold text-green-700 transition-all duration-500 group-hover:scale-110 group-hover:-translate-y-1">
                    {post.id}
                  </div>

                </div>

                {/* =========================
                    CONTENT
                ========================== */}
                <div className="relative p-5 flex flex-col flex-1">

                  <h3 className="font-bold text-[18px] leading-[1.35] text-[#173a20] mb-3 line-clamp-3 transition-colors duration-300 group-hover:text-green-700">
                    {post.title}
                  </h3>

                  <p className="text-gray-600 line-clamp-5 mb-5 text-[14px] leading-6">
                    {post.excerpt}
                  </p>

                  {/* Read More */}
                  <div className="mt-auto">

                    <a
                      href={post.link}
                      className="read-more-btn inline-flex items-center justify-center gap-2 bg-[#35A93E] hover:bg-[#2E8C36] text-white text-xs font-semibold px-4 py-2.5 rounded-full transition-all duration-300"
                    >
                      <span>Read More</span>

                      <span className="arrow-icon transition-transform duration-300">
                        →
                      </span>
                    </a>

                  </div>

                </div>

                {/* Bottom green line */}
                <div className="absolute bottom-0 left-0 right-0 h-[3px] bg-green-600 scale-x-0 origin-left group-hover:scale-x-100 transition-transform duration-500" />

              </article>

            ))
          ) : (
            <p className="text-center text-gray-500 col-span-3 py-10">
              No matching blogs found.
            </p>
          )}

        </div>
      </div>

      {/* =========================
          PROFESSIONAL 3D CSS
      ========================== */}
      <style>{`

        /* Main card */
        .blog-card {
          border: 1px solid rgba(53, 169, 62, 0.10);

          box-shadow:
            0 5px 15px rgba(20, 60, 30, 0.06),
            0 15px 35px rgba(20, 60, 30, 0.08);

          transform: translateY(0) perspective(1000px);

          transition:
            transform 0.45s cubic-bezier(.2,.8,.2,1),
            box-shadow 0.45s ease,
            border-color 0.45s ease;

          animation: blogAppear 0.7s ease both;
        }

        /* Premium 3D hover */
        .blog-card:hover {
          transform:
            translateY(-9px)
            perspective(1000px)
            rotateX(1deg)
            rotateY(-1deg);

          border-color: rgba(53, 169, 62, 0.20);

          box-shadow:
            0 10px 20px rgba(20, 60, 30, 0.08),
            0 25px 55px rgba(20, 60, 30, 0.14);
        }

        /* Image zoom + lift */
        .blog-card:hover .blog-image {
          transform:
            scale(1.045)
            translateY(-2px);
        }

        /* Read More button */
        .read-more-btn {
          box-shadow:
            0 5px 12px rgba(53, 169, 62, 0.20);

          transform: translateY(0);

          transition:
            transform 0.3s ease,
            box-shadow 0.3s ease,
            background-color 0.3s ease;
        }

        .read-more-btn:hover {
          transform: translateY(-2px);

          box-shadow:
            0 8px 18px rgba(53, 169, 62, 0.28);
        }

        /* Arrow movement */
        .blog-card:hover .arrow-icon {
          transform: translateX(4px);
        }

        /* Card entrance */
        @keyframes blogAppear {
          from {
            opacity: 0;
            transform: translateY(25px);
          }

          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        /* Mobile */
        @media (max-width: 640px) {

          .blog-card:hover {
            transform: translateY(-5px);
          }

          .blog-card {
            box-shadow:
              0 5px 15px rgba(20, 60, 30, 0.07);
          }

        }

        /* Respect reduced motion */
        @media (prefers-reduced-motion: reduce) {

          .blog-card,
          .blog-image,
          .read-more-btn,
          .arrow-icon {
            animation: none !important;
            transition: none !important;
          }

          .blog-card:hover {
            transform: none;
          }

        }

      `}</style>
    </div>
  );
}